import React from 'react';
import { OrganizationalStructureProvider } from './context/organizational-structure-context';
import { OrganizationalStructurePage } from './organizationalStructure.page';

export const OrganizationalStructureFactory: React.FC = () => {
  return (
    <OrganizationalStructureProvider>
      <OrganizationalStructurePage />
    </OrganizationalStructureProvider>
  );
};